(function(module) {
    'use strict';

    function UnverifiedAccountConfig($stateProvider, $translatePartialLoaderProvider) {

        // Route
        $stateProvider
            .state('unverified-account', {
                url: '/unverified-account',
                data: {
                    pageTitle: 'UNVERIFIED.PAGE_TITLE',
                },
                views: {
                    'main@': {
                        templateUrl: '/js/components/layouts/content-only.html',
                        controller: 'MainController as $ctrl',
                    },
                    'content@unverified-account': {
                        templateUrl: '/js/authentication/unverified-account/unverified-account.html',
                        controller: 'UnverifiedAccountCtrl as $ctrl',
                    },

                },
                resolve: {
                    currentUser: function(User) {
                        return User.getCurrent().$promise.then(function(response) {
                            return response;
                        });
                    },
                    account: function(currentUser, Account, $state) {
                        const accountId = currentUser.accountId;
                        Account.findById({ id: accountId })
                            .$promise
                            .then(function(account) {
                                if (account.enabled && account.accountVerified) {
                                    $state.go('root.home');
                                }
                                if (!account.enabled) {
                                    $state.go('root.blocked-account');
                                }
                            });

                    },
                },
                bodyClass: 'page--unverified-account',
            });

        // Translations
        $translatePartialLoaderProvider.addPart('/js/authentication/unverified-account');

    }

    function UnverifiedAccountCtrl(LoopBackAuth, Store, $state) {
        this.clearCookies = () => {
            Store.setCurrentSubAccountId(null);
            LoopBackAuth.clearUser();
            LoopBackAuth.clearStorage();
            $state.go('login');

        };

    }

    module
        .config(UnverifiedAccountConfig)
        .controller('UnverifiedAccountCtrl', UnverifiedAccountCtrl);

})
(angular.module('rocket.components'));
